import { numberWithCommas, percentageString } from './NumberUtils';

export const commonEchartsTooltipFormatter = (params: any[]) => {
  let result = `${params[0].axisValueLabel}<br/>`;
  params.forEach((param) => {
    if (!isNaN(param.value)) {
      result += `
                <div style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  font-size: 12px;
                  margin-bottom: 2px;
                  gap: 30px;
                ">
                  <!-- 왼쪽: 마커 + 시리즈명 -->
                  <span style="display: inline-flex; align-items: center;">
                    ${param.marker}
                    <span style="margin-left: 4px;">${param.seriesName}</span>
                  </span>
                  <!-- 오른쪽: 값 -->
                  <span>${numberWithCommas(param.value)}원</span>
                </div>
              `;
    }
  });
  return result;
};

export const commonEchartsLabelFormatter = (params: any, totalValue: number) => {
  const percent = (params.value / totalValue) * 100;
  if (percent < 10) return '';
  return `${params.seriesName} ${percentageString(percent)}`;
};
